/** Keys allowed through a digit-only input (navigation/editing, not characters). */
export const ONLY_DIGITS_ALLOWED_KEYS = [
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'Meta',
  'Control',
];

/** True if the pressed key would enter a non-digit character. */
export const isNonDigitKey = (key: string): boolean =>
  !ONLY_DIGITS_ALLOWED_KEYS.includes(key) && (key < '0' || key > '9');

/** Block non-digit keys in a digits-only input, but allow Cmd/Ctrl shortcuts (e.g. paste). */
export const shouldBlockNonDigitKey = (e: {
  key: string;
  metaKey: boolean;
  ctrlKey: boolean;
}): boolean => isNonDigitKey(e.key) && !e.metaKey && !e.ctrlKey;

/** True if the string contains any non-digit character (e.g. a pasted value). */
export const hasNonDigits = (value: string): boolean => /\D/.test(value);
